import type { PropsWithChildren } from 'react';
import type React from 'react';

import { Button } from '@change/ds-core-ui/Button';
import { Text } from '@change/ds-core-ui/Text';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';
import type { QrCodeType } from '@change-corgi/middle-end-gql-schema';

import { useAsyncDownload } from '#src/app/shared/hooks/download';

import { getPetitionQRCodeImage } from './api';

export const QRCodeDownloadLink: React.FC<
	PropsWithChildren<{
		slugOrId: string;
		type: QrCodeType;
		size?: number;
		filename?: string;
		onClick?: (data: { shareId: string | null | undefined }) => Promise<void>;
	}>
> = ({ children, slugOrId, size, type, filename, onClick }) => {
	const utilityContext = useUtilityContext();

	const { actions } = useAsyncDownload({
		fetchData: async () => {
			const qrCode = await getPetitionQRCodeImage({ slugOrId, type, size, utilityContext });
			return { dataUri: qrCode.imageBase64Uri, shareId: qrCode.shareId };
		},
		filename: filename || 'petition-qrcode.png',
		onDownload: async ({ shareId }) => {
			await onClick?.({ shareId });
		},
	});

	return (
		<Button
			onClick={actions.handleDownload}
			variant="secondary"
			size="small"
			data-qa="qrcode-download-link"
			data-testid="qrcode-download-link"
		>
			<Text variant="body" size="medium" fontWeight="bold">
				{children}
			</Text>
		</Button>
	);
};
